<mat-spinner *ngIf="spinner" class="center"></mat-spinner>

<section>


  <!-- CLOSE BUTTON -->
  <button type="button" class="close-button m-2 mb-0"
      mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <!-- <h4 mat-dialog-title>Študijné programy</h4> -->
  <div mat-dialog-title>{{getTitle()}}</div>

  <mat-dialog-content class="mat-typography m-auto">

    @if (typZobrazovanychDat === appStateService.ZAVERECNE_PRACE_VEDENE) {

      @for (typ of typyZaverecnychPracMap.keys(); track typ; let i = $index) {

        <div class="mb-1 ms-2" [ngClass]="{'mt-3' : i > 0}">
          <span class="h6 fw-semibold">{{typyZaverecnychPracMap.get(typ)}}</span>
          - <span i18n>počet</span>: {{getPocetPracTypu(typ)}}
        </div>

        @if (getPocetPracTypu(typ) > 0) {

          <div class="ms-2">

            <div class="row mt-3">

              <div class="col-5 h6">
                  <span i18n>Názov témy</span>
              </div>
              <div class="col-3 h6 text-center">
                  <span i18n>Katedra/Ústav</span>
              </div>
              <div class="col-4 h6">
                  <span i18n>Študent</span>
              </div>

            </div>


            @for (zp of typyZaverecnychPracAZoznamPracDanehoTypuMap.get(typ); track zp.studentPlneMeno; let last = $last) {

              <div class="row">

                <div class="col-5 align-content-center">
                  {{zp.nazovTemy}}
                </div>
                <div class="col-3 align-content-center text-center">
                  {{zp.katedraUstav}}
                </div>
                <div class="col-4 align-content-center">
                  {{zp.studentPlneMeno}} - {{zp.studProgram}}
                </div>

              </div>

              @if (!last) {
                <div class="divider">
                  <div class="divider-fade"></div>
                </div>
              }

            }

          </div>


        }

      }

    }


    @else if (typZobrazovanychDat === appStateService.ZAVERECNE_PRACE_OBHAJENE) {

      <mat-accordion multi="true">

        @for (typ of typyZaverecnychPracMap.keys(); track typ; let i = $index) {

          <mat-expansion-panel class="mt-2" [expanded]="typPrace > 0">

            <mat-expansion-panel-header>

                <div class="h6">
                  <span>{{typyZaverecnychPracMap.get(typ)}}</span>
                  - <span i18n>počet</span>:
                  <span>{{getPocetPracTypu(typ)}}</span>
                </div>

            </mat-expansion-panel-header>

            @if (getPocetPracTypu(typ) > 0) {

              <div class="row">

                <div class="col-5 h6">
                    <span i18n>Názov témy</span>
                </div>
                <div class="col-2 h6 text-center">
                    <span i18n>Katedra/Ústav</span>
                </div>
                <div class="col-3 h6">
                    <span i18n>Študent</span>
                </div>
                <div class="col-2 h6">
                    <span i18n>Obhajoba</span>
                </div>

              </div>

              @for (zp of typyZaverecnychPracAZoznamPracDanehoTypuMap.get(typ);
                track zp.studentPlneMeno; let last = $last) {

                <div class="row">

                  <div class="col-5 align-content-center">
                    {{zp.nazovTemy}}
                  </div>
                  <div class="col-2 align-content-center text-center">
                    {{zp.katedraUstav}}
                  </div>
                  <div class="col-3 align-content-center">
                    {{zp.studentPlneMeno}} - {{zp.studProgram}}
                  </div>
                  <div class="col-2 align-content-center">
                    {{zp.datumObhajenia | date:'dd.MM.yyyy'}}
                  </div>

                </div>

                @if (!last) {
                  <div class="divider">
                    <div class="divider-fade"></div>
                  </div>
                }


              }

            }


          </mat-expansion-panel>

        }

      </mat-accordion>

    }

  </mat-dialog-content>

  <mat-dialog-actions class="d-flex justify-content-end">
    <button mat-stroked-button mat-dialog-close i18n>Zrušiť</button>
    <button mat-stroked-button mat-dialog-close
      [disabled]="false"
      (click)="potvrditVyberZP()" i18n>Potvrdiť</button>
  </mat-dialog-actions>

</section>
